import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  QuestionnaireStepper: {
    maxWidth: '75%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

const QuestionnaireStepper = ({ stepsNumber, current }) => {
  const classes = useStyles();
  const content = [];

  for (let i = 0; i < stepsNumber; i += 1) {
    content.push(
      <Step key={`question-step-${i}`}>
        <StepLabel />
      </Step>,
    );
  }

  return (
    <Stepper activeStep={current} classes={{ root: classes.QuestionnaireStepper }}>
      {content}
    </Stepper>
  );
};

QuestionnaireStepper.propTypes = {
  stepsNumber: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
};

export default QuestionnaireStepper;
